import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.mobile-numbers.list', {
        url: '',
        component: 'userPhoneNumberList',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/list/phone-number-list.state.js